import { SignUpPage } from "../components"

export default SignUpPage
